import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';


import { DashboardService } from 'app/dashboard/dashboard.service';
import { BillingserviceService } from '../billingService.service';

import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef,MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DialogData } from 'app/reports/reportdialog';

@Component({
  selector: 'app-visit',
  templateUrl: './visit.component.html',
  styleUrls: ['./visit.component.scss']
})
export class VisitComponent implements OnInit {
  urldata:any;
  todaysdate:any;
  VisitsArray:any =[];
  BIllDetails:any =[];
  RefoundAmount:number;
  InvestigationArray:any =[];
  reporturl: any;
  billDate:any;
  PatientId:number;
  // datePipe: any;
  constructor( private authService: AuthService, private dialog: MatDialog,
    private dashboardService: DashboardService, private datePipe: DatePipe,
    private opdvisitService: OpdVisitService, private dialogRef: MatDialogRef<VisitComponent>,
 
  @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  private billingservice: BillingserviceService){

  }
  ngOnInit(): void {
  
    // this.urldata=this.dashboardService.newbaseUrl+"WebAPIDevp/Project1.exe";
    
     this.getvisits(this.data.pid,0);
     this.RefoundAmount =0;
     this.getInsvestigation(this.data.pid);
     this.PatientId=this.data.pid;
     this.getproductmasterconfig();

  }
  closedialog(){
    this.dialog.closeAll();
    this.deleteprintData();
    }

  // getPatientsvisits(e:any){
  //   this.getvisits(e,0)
  // }

   getvisits(a,b){
       this.billingservice.getbillHistory( a,b).subscribe(data=>this.visit_Sucsess(data))
   }

   visit_Sucsess(data){
   this.VisitsArray =data;
   }
   insertBillSummery:any=[];
   
   rowClicked: any=-1;
   getbilldebitDetalis(id,date,val,indx){
   if(this.rowClicked != indx){
    this.rowClicked = indx;
   }
    var index = this.insertBillSummery.indexOf(val);
 if(index === -1){
   // val not found, pushing onto array
   this.insertBillSummery.push(val);
 }else{
   // val is found, removing from array
   this.insertBillSummery.splice(index,1);
 }

    this.billingservice.get_service_byID(id).subscribe(data=>{
      // console.log('billdetails',data);
      this.BIllDetails =data;
     });
  
    
   this.billDate =date;
    this.billingservice.get_visitors_refound(id).subscribe(data=>{
   
      if(data.statusCode){
        this.RefoundAmount =0;
      }
      else{
        this.RefoundAmount =data;
      }
     
    });
   }

    getInsvestigation(id){
      this.billingservice.getInvestigationdata(id).subscribe(data=>{
  
        this.InvestigationArray = data;

      })
    }

    getproductmasterconfig() {
      let BranchId = this.authService.Loggeduser.branchid;
      this.billingservice.getproductionConfrigration(BranchId).subscribe(data => {
        //console.log('master confrigartion',data);
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
         if(element.propertyName ==="WebURL"){
            this.reporturl = element.propertyValue;
          }
        }
      })
    }
  
    prientvisitData(){
    
      if( this.billDate){
        var insertsummery=[];
        if(this.insertBillSummery.length){
          this.insertBillSummery.forEach(item=>{
            insertsummery.push({
               "BillNo":item.billNo,
                "IsPrint":1
            });
          });
          this.billingservice.insertBillSelectBillSummary(insertsummery).subscribe((x:any)=>{
            let sdate = this.datePipe.transform(this.billDate, "yyyy-MM-dd");
            window.open(this.reporturl + 'OpdBillSummaryForSelectBill.aspx?RegID=' + this.PatientId +'&BranchId='+ this.authService.Loggeduser.branchid+'&BillingCompanyName='+this.authService.Loggeduser.companyname+ '&PageHeadWebReport='+ 'Y&BillDate='+sdate);
            // this.deleteprintData();
          });
        
          insertsummery=[];
        }
        
 
      }
      else{
       this.dashboardService.openSnackBar("Please Select Bill ", "OK");
      }
     
    }
    
    deleteprintData(){
      var insertsummery =[];
      insertsummery.push({
        "BillNo":0,
         "IsPrint":0
     });
      this.billingservice.insertBillSelectBillSummary(insertsummery).subscribe((x:any)=>{
      
      });
    }
    
    failedurl(err){
      this.dashboardService.openSnackBar("summary api url failed ", "OK");
      }



}
